var pics=[
    {src:require('../assets/lesson6/face1.gif'), isActive:true, isOver:false},
    {src:require('../assets/lesson6/face2.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face3.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face4.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face5.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face6.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face7.gif'), isActive:false, isOver:false},
    {src:require('../assets/lesson6/face8.gif'), isActive:false, isOver:false},
];

var lists=[
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'新增删除广播功能。',
        times:'07月05日 15:14',
        isLiActive:false
    },
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'新增Ctrl+Enter快捷键发送广播。',
        times:'07月05日 12:20',
        isLiActive:false
    },
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'新增选择头像功能',
        times:'07月05日 12:08',
        isLiActive:false
    },
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'增加了记录广播时间的功能',
        times:'07月04日 16:55',
        isLiActive:false
    },
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'增加了输入字符检测功能，英文/半角为半个字符，汉字/全角为一个字符。',
        times:'07月04日 08:30',
        isLiActive:false
    },
    {
        src:require('../assets/lesson6/face.gif'),
        username:'日丶久生情',
        msg:'仿腾讯微博效果，欢迎大家测试！',
        times:'07月03日 20:19',
        isLiActive:false
    },
];



export {pics, lists};